export default __webpack_public_path__ + "static/media/category_outlined.42101cbc.svg";